import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "./Footer.css";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaYoutube } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
export default function Footer() {
  const footerRef = useRef(null);
  const { pathname } = useLocation();

  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // GSAP animations
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".footer-section", {
        opacity: 0,
        y: 50,
        duration: 1,
        stagger: 0.3,
        ease: "power3.out",
      });

      gsap.from(".social-icons a", {
        opacity: 0,
        scale: 0.5,
        duration: 0.8,
        stagger: 0.2,
        ease: "back.out(1.7)",
        delay: 0.8,
      });
    }, footerRef);

    return () => ctx.revert();
  }, []);

  return (
    <footer className="footer" ref={footerRef}>
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-section">
          <h2>China Office :</h2>
          <p>
            ROOM 2nd FLR, C# BLDG NO.17#, YINCHANG AREA,
            BEIHUAN LIANGSHI ROAD, SHISHI CITY, <br/>FUJIAN
            P.R. CHINA. P.C: 362700
          </p>
          <br />
          <p><strong>Tel : </strong>86-0595-88568700 / 88613700</p>
          <p><strong>Fax :</strong>86-0595-88569700</p>
      <br/>
          <p> <strong>Mr. Mike (Sonu)</strong> </p> 
          <p><strong>Email :</strong> sonu@mayaexportsltd.com</p>
          <p><strong>Call & WhatsApp:</strong>+86-13506082198</p>
<br/>
<p><strong>Ms. Jenny (Roshni)</strong><br /> <strong>Email:</strong> roshni@mayaexportsltd.com<br /><strong>Call & WhatsApp:</strong>+86-13506082700</p>

<br/>
<p><strong>Ms. Sophie</strong><br /> 
 <strong>Email:</strong> sophie_maya86@yahoo.com<br /><strong>Call & WhatsApp:</strong>+86-13859781105</p>

        </div>

        {/* Middle Section */}
        <div className="footer-section">
          <h2>Hongkong Office :</h2>
          <p>
             KENSINGTON PLAZA, 98 PARKES STREET,
            JORDAN, KOWLOON, HONG KONG.
          </p>
          <p><strong>Email:</strong> sonu@mayaexportsltd.com</p>
          <p><strong>Mr. Mike (Sonu):</strong> +852-68580690</p>
        </div>

        {/* Social Section */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <Link to="https://www.instagram.com/mayaexportslimited?igsh=MWZkbWk5aW9oZWhvbw%3D%3D&utm_source=qr "><FaInstagram /></Link>
            <Link to="https://www.facebook.com/share/16nhuUoFFN/?mibextid=wwXIfr"><FaFacebook /></Link>
            <Link to=""><FaLinkedin /></Link>
            <Link to="https://x.com/mayaexports07 "><FaTwitter /></Link>
          
          </div>
        </div>

        {/* Links Section */}
        <div className="footer-section footer-links">
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <HashLink smooth to="/#mens-showcase">Products</HashLink>
          <Link to="/event">Event</Link>
          <Link to="/career">Career</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Copyright © 2025 Maya Exports LTD | Powered by{" "}
          <strong>Big Feathers Technology</strong>
        </p>
      </div>
    </footer>
  );
}
